.mainHeader {
	margin-top: 0;
	min-height: 1.2em;
}
